// Public identity only. Never use the display name as a tenant or storage key.
export const COUNTER_CULTURE = Object.freeze({
  key: "rolls_and_brew",
  name: "Counter Culture",
  fullName: "Counter Culture - by Chef Sadiq",
  byline: "by Chef Sadiq",
  tagline: "FRESHLY FOLDED, FIERCELY FIRED",
  logo: "/brand/counter-culture/logo-approved.png",
  icon: "/brand/counter-culture/icon-192.png",
  themeColor: "#052D2D",
  cream: "#F5F0E6",
  accent: "#126D68",
});
export function counterCultureProfile(profile) {
  if (profile?.brand_key !== COUNTER_CULTURE.key) return profile;
  return { ...profile, display_name: COUNTER_CULTURE.fullName,
    logo_url: COUNTER_CULTURE.logo, icon_url: COUNTER_CULTURE.icon,
    tagline: COUNTER_CULTURE.tagline };
}
// Presentation adapter: do not write this value back to the source record.
export function brandDisplayLabel(value) {
  if (typeof value !== "string") return value;
  return value.replace(/\brolls\s+(?:&amp;|&|and)\s+brew(?:\s+co\.?)?(?!\w)(?:\s*[—–·-]?\s*by\s+chef\s+sadiq)?/gi,
    "Counter Culture - by Chef Sadiq");
}
